"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserPlxData = exports.UserPlxDataProvider = exports.UserPlxDataContext = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var hooks_1 = require("../hooks");
exports.UserPlxDataContext = (0, react_1.createContext)({});
var UserPlxDataProvider = function (_a) {
    var children = _a.children;
    var _b = (0, react_1.useState)({}), contextObj = _b[0], setContextObject = _b[1];
    var data = (0, hooks_1.useGetUserSettings)().data;
    (0, react_1.useEffect)(function () {
        setContextObject({
            userItemID: data === null || data === void 0 ? void 0 : data.userid,
            dbName: data === null || data === void 0 ? void 0 : data.dbname,
            dbAlias: data === null || data === void 0 ? void 0 : data.dbalias,
        });
    }, [data]);
    return (react_1.default.createElement(exports.UserPlxDataContext.Provider, { value: contextObj }, children));
};
exports.UserPlxDataProvider = UserPlxDataProvider;
var useUserPlxData = function () { return (0, react_1.useContext)(exports.UserPlxDataContext); };
exports.useUserPlxData = useUserPlxData;
